import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[alphanumericOnly]',
  standalone: false,
})
export class AllowAlphanumericDirective {
  regexStr: string = '^[a-zA-Z0-9]+$';

  constructor(private _el: ElementRef) {}

  @HostListener('keypress', ['$event'])
  public onKeyPress(event: any) {
    return new RegExp(this.regexStr).test(event.key);
  }

  @HostListener('paste', ['$event'])
  blockPaste(event: ClipboardEvent) {
    this.validationFields(event);
  }

  validationFields(event: ClipboardEvent) {
    event.preventDefault();
    const pasteData = event.clipboardData?.getData('text/plain').replace(/[^a-zA-Z0-9]/g, '');
    document.execCommand('insertHTML', false, pasteData);
  }
}
